import { useEffect, useState } from 'react'
import { useRouteError } from 'react-router'

import { ErrorPanel } from '../components/ErrorPanel'

/**
 * The router's error surface.
 *
 * react-router's built-in fallback prints the exception and a JavaScript stack
 * trace. That is a development affordance; on a customer's screen it is both
 * unusable and a description of the platform's internals — the file names of
 * our own source. This replaces it with the same panel a render crash
 * produces, and sends the detail to the browser console instead.
 */
export function RouteErrorPage() {
  const error = useRouteError()
  // Lazy initial state, not a call during render: a render may run more than
  // once, and the reference the operator quotes must match the one logged.
  const [reference] = useState(() => Math.random().toString(36).slice(2, 8).toUpperCase())

  useEffect(() => {
    console.error(`[client-portal] route error ref=${reference}`, error)
  }, [error, reference])

  return <ErrorPanel reference={reference} onRetry={() => window.location.reload()} />
}
